import React, { useEffect, useState } from "react";
import FilterBar from "../common/FilterBar";
import { Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import ProductOne from "../assets/images/product1.svg";
import ProductTwo from "../assets/images/product2.svg";
import Page from "./Page";
import { apiRequest } from "../utils/comman/apiRequest";
import { Urls } from "../utils/endPoints/apiUrls";
import DatePicker from "react-datepicker";
import { fDate } from "../utils/fileHelper";
import Pagination from "./comman/Pagination";
import Loader from "./comman/Loader";

export default function Availability() {
  const [filters, setFilters] = useState({
    // date: fDate(new Date()),
    startDate: new Date(),
    endDate: new Date(),
    selectedMaterials: [""],
    selectedTypes: [""],
    selectedSizes: [""],
    marketplace: "Amazon",
  });

  const [brandData, setBrandData] = useState([]);
  const [materialDropDown, setMaterialDropDown] = useState([]);
  const [typeDropDown, setTypeDropDown] = useState([]);
  const [productSize, setProductSize] = useState([]);

  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [isLoading, setIsLoading] = useState(false);

  // Table Data -------------------------------

  const fetchProducts = async (customFilters = filters) => {
    setIsLoading(true);
    const query = {
      startDate: customFilters.startDate,
      endDate: customFilters.endDate,
      material: customFilters.selectedMaterials?.[0] || "",
      type: customFilters.selectedTypes?.[0] || "",
      size: customFilters.selectedSizes?.[0] || "",
      marketplace: customFilters.marketplace || "",
    };

    const { data, status } = await apiRequest({
      endUrl: Urls.availabilty,
      method: "GET",
      query: { ...query, ...pagination },
    });
    if (status) {
      // setBrandData(data?.rows);
      setIsLoading(false);
      setBrandData({
        ...brandData,
        rows: data?.rows,
        count: data?.totalPages,
        limit: data?.limit,
        page: data?.page,
      });
    }
  };

  // Material Dropdown -------------------------

  const fetchMaterialDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.materialDropDown,
    });
    if (status) {
      setMaterialDropDown(data?.rows);
    }
  };

  // Types Dropdown --------------------------

  const fetchTypesDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.productTypes,
    });
    if (status) {
      setTypeDropDown(data?.rows);
    }
  };

  // Size Dropdown --------------------------

  const fetchSizesDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.productSize,
    });
    if (status) {
      setProductSize(data?.rows);
    }
  };

  // const toggleSelection = (value, key) => {
  //   setFilters((prev) => {
  //     const currentArray = prev[key];
  //     const updatedArray = currentArray.includes(value)
  //       ? currentArray.filter((v) => v !== value)
  //       : [...currentArray, value];

  //     return {
  //       ...prev,
  //       [key]: updatedArray,
  //     };
  //   });
  // };

  // const toggleSelection = (value, key) => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     [key]: [value],
  //   }));
  // };
  const toggleSelection = (value, key) => {
    setFilters((prev) => {
      const isAlreadySelected = prev[key]?.includes(value);

      return {
        ...prev,
        [key]: isAlreadySelected ? [] : [value],
      };
    });
  };

  useEffect(() => {
    fetchProducts();
    fetchMaterialDropdown();
    fetchTypesDropdown();
    fetchSizesDropdown();
  }, [filters, pagination]);

  // -----------------------------

  const [dropdowns, setDropdowns] = useState({
    material: false,
    type: false,
    size: false,
    marketplace: false,
  });

  const handleDropdownToggle = (key, isOpen) => {
    setDropdowns((prev) => ({ ...prev, [key]: isOpen }));
  };

  const closeDropdown = (key) => {
    setDropdowns((prev) => ({ ...prev, [key]: false }));
  };

  return (
    <Page title={"Availability"} subtitle={"Dashboard > Availability"}>
      <Container>
        <Row className="mt-3">
          <Col md={12}>
            <Row className="align-items-center g-0 filterrow">
              <Col xs={12} md={4}>
                <div className="d-flex align-items-center">
                  <Form.Label className="mb-0 filterText me-1 ms-2">
                    Start Date:
                  </Form.Label>
                  <DatePicker
                    selected={filters.startDate}
                    onChange={(newDate) =>
                      setFilters((prev) => ({ ...prev, startDate: newDate }))
                    }
                    selectsStart
                    startDate={filters.startDate}
                    endDate={filters.endDate}
                    dateFormat="dd MMMM yyyy"
                    className="form-control date-formcontrol me-2"
                  />
                  <Form.Label className="mb-0 filterText me-1 ms-2">
                    End Date:
                  </Form.Label>
                  <DatePicker
                    selected={filters.endDate}
                    onChange={(newDate) =>
                      setFilters((prev) => ({ ...prev, endDate: newDate }))
                    }
                    selectsEnd
                    startDate={filters.startDate}
                    endDate={filters.endDate}
                    dateFormat="dd MMMM yyyy"
                    className="form-control date-formcontrol"
                  />
                </div>
              </Col>

              <Col>
                <Dropdown
                  show={dropdowns.material}
                  onToggle={(isOpen) =>
                    handleDropdownToggle("material", isOpen)
                  }
                >
                  <Dropdown.Toggle
                    variant="outline-secondary dropbtn"
                    style={{ borderRight: 0 }}
                  >
                    Material:{" "}
                    <span className="droptxt">
                      {filters.selectedMaterials[0] || "Select"}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Form.Label className="px-3 filterText">
                      Select Material
                    </Form.Label>
                    {materialDropDown.map((mat) => (
                      <Form.Check
                        key={mat?.name}
                        type="checkbox"
                        label={mat?.name}
                        checked={filters.selectedMaterials.includes(mat.name)}
                        // onChange={() => toggleSelection(mat?.name, "selectedMaterials")}
                        onChange={() => {
                          toggleSelection(mat?.name, "selectedMaterials");
                          closeDropdown("material");
                        }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>

              <Col>
                <Dropdown
                  show={dropdowns.type}
                  onToggle={(isOpen) => handleDropdownToggle("type", isOpen)}
                >
                  <Dropdown.Toggle
                    variant="outline-secondary dropbtn"
                    style={{ borderRight: 0 }}
                  >
                    Type:
                    <span className="droptxt">
                      {filters.selectedTypes[0] || "Select"}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Form.Label className="px-3 filterText">
                      Select Type
                    </Form.Label>
                    {typeDropDown.map((type) => (
                      <Form.Check
                        key={type?.name}
                        type="checkbox"
                        label={type?.name}
                        checked={filters.selectedTypes.includes(type?.name)}
                        // onChange={() => toggleSelection(type?.name, 'selectedTypes')}
                        onChange={() => {
                          toggleSelection(type?.name, "selectedTypes");
                          closeDropdown("type");
                        }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>

              <Col>
                <Dropdown
                  show={dropdowns.size}
                  onToggle={(isOpen) => handleDropdownToggle("size", isOpen)}
                >
                  <Dropdown.Toggle
                    variant="outline-secondary dropbtn"
                    style={{
                      borderRight: 0,
                      borderTopRightRadius: 8,
                      borderBottomRightRadius: 8,
                    }}
                  >
                    Size:
                    <span className="droptxt">
                      {filters.selectedSizes[0] || "Select"}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Form.Label className="px-3 filterText">
                      Select Size
                    </Form.Label>
                    {productSize.map((size) => (
                      <Form.Check
                        key={size?.name}
                        type="checkbox"
                        label={size?.name}
                        checked={filters.selectedSizes.includes(size?.name)}
                        // onChange={() => toggleSelection(size?.name, 'selectedSizes')}
                        onChange={() => {
                          toggleSelection(size?.name, "selectedSizes");
                          closeDropdown("size");
                        }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>

              <Col>
                <Dropdown
                  show={dropdowns.marketplace}
                  onToggle={(isOpen) =>
                    handleDropdownToggle("marketplace", isOpen)
                  }
                >
                  <Dropdown.Toggle
                    variant="outline-secondary dropbtn"
                    style={{
                      borderRight: 0,
                      borderTopRightRadius: 8,
                      borderBottomRightRadius: 8,
                    }}
                  >
                    Marketplace:{" "}
                    <span className="droptxt">
                      {filters.marketplace || "Select"}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Form.Label className="px-3 filterText">
                      Select Marketplace
                    </Form.Label>
                    {["Amazon", "Flipkart"].map((market) => (
                      <Form.Check
                        key={market}
                        type="checkbox"
                        label={market}
                        checked={filters.marketplace === market}
                        onChange={() => {
                          setFilters((prev) => {
                            const isSame = prev.marketplace === market;
                            return {
                              ...prev,
                              marketplace: isSame ? "Amazon" : market, // fallback to Amazon if same clicked
                            };
                          });
                          closeDropdown("marketplace");
                        }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
          </Col>

          <Col md={12}>
            <hr className="my-4" style={{ color: "#666666" }} />
          </Col>

          <Col md={6}>
            <div className="availabilitybox">
              <img src={ProductOne} alt="" className="me-4" />
              <p className="productTxt mb-0">
                <span>--</span> No. of Products
              </p>
            </div>
          </Col>

          <Col md={6}>
            <div className="availabilitybox">
              <img src={ProductTwo} alt="" className="me-4" />
              <p className="productTxt mb-0">
                <span>--</span> Products at Instance
              </p>
            </div>
          </Col>

          <Col md={12}>
            <hr className="my-4" style={{ color: "#666666" }} />
          </Col>

          <Col md={12}>
            <div className="table-responsive dataTable mt-4">
              <table
                cellPadding={10}
                cellSpacing={10}
                style={{
                  width: "100%",
                }}
              >
                <thead className="custom-header">
                  <tr>
                    <th>Material</th>
                    <th>Type</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Speed</th>
                    <th>City</th>
                    <th>Zip Code</th>
                    <th>Product URL</th>
                  </tr>
                </thead>
                <tbody className="custom-body">
                  {isLoading ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  ) : brandData?.rows?.length > 0 ? (
                    brandData?.rows?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.material || "-"}</td>
                        <td>{item.type || "-"}</td>
                        <td>{item.size || "-"}</td>
                        <td>{item.price || "-"}</td>
                        <td>{item.speed || "-"}</td>
                        <td>{item.city || "-"}</td>
                        <td>{item.zipCode || "-"}</td>
                        <td>
                          <a
                            href={item.productUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.productUrl}
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Col>

          <Col md={12} className="mt-4">
            <Pagination
              count={brandData?.count}
              rowsPerPage={brandData?.limit}
              page={brandData?.page}
              onPageChange={(page) =>
                setPagination({ ...pagination, page: page + 1 })
              }
              onRowsPerPageChange={(page, limit) =>
                setPagination({ ...pagination, page: 1, limit })
              }
            />
          </Col>
        </Row>
      </Container>
    </Page>
  );
}
